import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import MDEditor, { commands } from '@uiw/react-md-editor'
import rehypeSanitize from 'rehype-sanitize'
import remarkBreaks from 'remark-breaks'

const AllowedCommands = [
  commands.bold,
  commands.italic,
  commands.strikethrough,
  commands.divider,
  commands.code,
  commands.codeBlock,
  commands.divider,
  commands.orderedListCommand,
  commands.unorderedListCommand,
  commands.divider,
  commands.hr,
]

interface CustomRichTextEditorProps {
  value: string
  onChange: (value?: string) => void
}

export const renderPreview = (value: string) => {
  return (
    <div data-color-mode="light">
      <MDEditor.Markdown
      source={value}
      remarkPlugins={[remarkBreaks]}
      rehypePlugins={[[rehypeSanitize]]}
      style={{ backgroundColor: 'inherit' }}
    />
    </div>
    
  )
}

const CustomRichTextEditor = ({ value, onChange }: CustomRichTextEditorProps) => {
  const renderMarkdownEditor = () => (
    <MDEditor
      value={value}
      onChange={onChange}
      commands={AllowedCommands}
      previewOptions={{
        remarkPlugins: [remarkBreaks],
        rehypePlugins: [[rehypeSanitize]],
      }}
    />
  )

  return (
    <div data-color-mode='light'>
      <Tabs colorScheme='purple' size='sm'>
        <TabList maxW='max-content'>
          <Tab>Write</Tab>
          <Tab>Preview</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>{renderMarkdownEditor()}</TabPanel>
          <TabPanel>{renderPreview(value)}</TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  )
}

export default CustomRichTextEditor
